import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const saveNoShowAppointmentFeedbackApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    saveNoShowAppointmentFeedback: builder.mutation({
      query: ({ body, preferredLanguage }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Appointment/noshow-appointment-feedback`,
          method: "POST",
          data: body,
          headers,
        };
      },
      invalidatesTags: (result, error) => [{ type: "NoShowAppointment" }],
    }),
  }),
  overrideExisting: false,
});

export const { useSaveNoShowAppointmentFeedbackMutation } =
  saveNoShowAppointmentFeedbackApi;
export default saveNoShowAppointmentFeedbackApi;
